module.exports = __webpack_public_path__ + "static/media/country_mc.955e2e2f.webp";